import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=02faf8e6&scoped=true"
import script from "./NeedHelp.vue?vue&type=script&lang=js"
export * from "./NeedHelp.vue?vue&type=script&lang=js"
import style0 from "./NeedHelp.vue?vue&type=style&index=0&id=02faf8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02faf8e6",
  null
  
)

export default component.exports